import {Injectable} from '@angular/core';
import {Observable, Subscription} from 'rxjs';

declare var jquery: any;
declare var $: any;

@Injectable()
export class WindowService {

  private _timer: Subscription;

  constructor() {}

  public scrollTop(): void {
    this._timer = Observable.interval(200).subscribe(
      () => {
        $(window).scrollTop(0);
        this._timer.unsubscribe();
        return;
      }
    );
  }
}



// WEBPACK FOOTER //
// /Users/mizunoe_jing/Documents/nice_day_current/bitbucket/starbright/src/app/service/window/window.service.ts